import RequestPassword from './RequestPasswordContainer';

export default RequestPassword;
